import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NkDatatableAbstractColumnComponent } from '../../datatable.utils';

@Component({
  selector: 'nk-text-column',
  imports: [AsyncPipe, TranslateModule],
  templateUrl: './text-column.component.html',
  styleUrls: ['./text-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextColumnComponent<T> extends NkDatatableAbstractColumnComponent<T> {
  public text$: Observable<string | null> = this.value$.pipe(
    map((value) => {
      if (value && value.row && value.prop) {
        const item = value.row && value.row[value.prop];
        if (typeof item === 'string') {
          return item;
        }
      }
      return null;
    }),
  );
}
